var map = {
	"./skins/IBC-dyst": [
		194,
		20
	],
	"./skins/IBC-dyst-2025": [
		193,
		21
	],
	"./skins/IBC-dyst-2025.css": [
		554,
		45
	],
	"./skins/IBC-dyst-2025.js": [
		193,
		21
	],
	"./skins/IBC-dyst.css": [
		555,
		44
	],
	"./skins/IBC-dyst.js": [
		194,
		20
	],
	"./skins/aktionaerliga-2024": [
		195,
		19
	],
	"./skins/aktionaerliga-2024.css": [
		556,
		43
	],
	"./skins/aktionaerliga-2024.js": [
		195,
		19
	],
	"./skins/aktionaerliga-2025": [
		196,
		18
	],
	"./skins/aktionaerliga-2025.css": [
		557,
		42
	],
	"./skins/aktionaerliga-2025.js": [
		196,
		18
	],
	"./skins/bibliotekarernes-sep-2024": [
		197,
		17
	],
	"./skins/bibliotekarernes-sep-2024.css": [
		558,
		41
	],
	"./skins/bibliotekarernes-sep-2024.js": [
		197,
		17
	],
	"./skins/boersen-spiel-sep-2024": [
		198,
		16
	],
	"./skins/boersen-spiel-sep-2024.css": [
		559,
		40
	],
	"./skins/boersen-spiel-sep-2024.js": [
		198,
		16
	],
	"./skins/borsgruppenliu-jan-2024": [
		199,
		15
	],
	"./skins/borsgruppenliu-jan-2024.css": [
		560,
		39
	],
	"./skins/borsgruppenliu-jan-2024.js": [
		199,
		15
	],
	"./skins/eadania": [
		200,
		14
	],
	"./skins/eadania.css": [
		561,
		38
	],
	"./skins/eadania.js": [
		200,
		14
	],
	"./skins/fynske-bank-sep-2024": [
		201,
		13
	],
	"./skins/fynske-bank-sep-2024.css": [
		562,
		37
	],
	"./skins/fynske-bank-sep-2024.js": [
		201,
		13
	],
	"./skins/ibc-jan-2024": [
		202,
		22
	],
	"./skins/ibc-jan-2024.js": [
		202,
		22
	],
	"./skins/rosborg-gym-2026": [
		203,
		12
	],
	"./skins/rosborg-gym-2026.css": [
		563,
		36
	],
	"./skins/rosborg-gym-2026.js": [
		203,
		12
	],
	"./skins/sdu-businessschooldays-2024": [
		204,
		11
	],
	"./skins/sdu-businessschooldays-2024.css": [
		564,
		35
	],
	"./skins/sdu-businessschooldays-2024.js": [
		204,
		11
	],
	"./skins/sdu-businessschooldays-2025": [
		205,
		10
	],
	"./skins/sdu-businessschooldays-2025.css": [
		565,
		34
	],
	"./skins/sdu-businessschooldays-2025.js": [
		205,
		10
	],
	"./skins/skoledyst-oct-2023": [
		206,
		9
	],
	"./skins/skoledyst-oct-2023.css": [
		566,
		33
	],
	"./skins/skoledyst-oct-2023.js": [
		206,
		9
	],
	"./skins/skolernes-aktiedyst-2024": [
		207,
		8
	],
	"./skins/skolernes-aktiedyst-2024.css": [
		567,
		32
	],
	"./skins/skolernes-aktiedyst-2024.js": [
		207,
		8
	],
	"./skins/skolernes-aktiedyst-2025": [
		208,
		7
	],
	"./skins/skolernes-aktiedyst-2025.css": [
		568,
		31
	],
	"./skins/skolernes-aktiedyst-2025.js": [
		208,
		7
	],
	"./skins/sommerdysten-ad-2023": [
		209,
		6
	],
	"./skins/sommerdysten-ad-2023.css": [
		569,
		30
	],
	"./skins/sommerdysten-ad-2023.js": [
		209,
		6
	],
	"./skins/sommerdysten-ak-2023": [
		210,
		5
	],
	"./skins/sommerdysten-ak-2023.css": [
		570,
		29
	],
	"./skins/sommerdysten-ak-2023.js": [
		210,
		5
	],
	"./skins/sommerdysten-is-2023": [
		211,
		4
	],
	"./skins/sommerdysten-is-2023.css": [
		571,
		28
	],
	"./skins/sommerdysten-is-2023.js": [
		211,
		4
	],
	"./skins/sydbank-sep-2020": [
		212,
		3
	],
	"./skins/sydbank-sep-2020.css": [
		572,
		27
	],
	"./skins/sydbank-sep-2020.js": [
		212,
		3
	],
	"./skins/targo-2025": [
		213,
		2
	],
	"./skins/targo-2025.css": [
		573,
		26
	],
	"./skins/targo-2025.js": [
		213,
		2
	],
	"./skins/ung_aktiedyst_2025": [
		214,
		1
	],
	"./skins/ung_aktiedyst_2025.css": [
		574,
		25
	],
	"./skins/ung_aktiedyst_2025.js": [
		214,
		1
	],
	"./skins/ungdomsudddyst-oct-2024": [
		215,
		0
	],
	"./skins/ungdomsudddyst-oct-2024.css": [
		575,
		24
	],
	"./skins/ungdomsudddyst-oct-2024.js": [
		215,
		0
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 360;
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/dynamic lazy ^\.\/.*$
// module id = 360
// module chunks = 46